import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../config.service';
import { Observable } from 'rxjs';
import { DateRange } from '../../models/date-range';
import { CalendarPlanerParameters } from '../../models/calendar/calendar-planer-parameters';
import {
  AbsencePlanerUserList,
  CalendarItem,
  CalendarWorkItemCount,
} from '../../models/client-models';

const CALENDAR_ITEMS_ENDPOINT = 'calendarItems';

@Injectable({
  providedIn: 'root',
})
export class CalendarItemBackendService {
  constructor(private http: HttpClient) {}

  /**
   * Select all Calendar Item (Absences and Official off days).
   *
   * @param date selected Date.
   * @param idPerson id of user.
   */
  public getCalendarItems(
    date: Date,
    idPerson: number
  ): Observable<CalendarItem[]> {
    return this.http.get<CalendarItem[]>(
      AppConfig.settings.backend.url +
        CALENDAR_ITEMS_ENDPOINT +
        '?idPerson=' +
        idPerson +
        '&date=' +
        date.toDateString()
    );
  }

  /**
   * Select all Calendar Item (TimeEntries no absences).
   *
   * @param date selected Date.
   * @param idPerson id of user.
   */
  public getCalendarWorkItems(
    date: Date,
    idPerson: number
  ): Observable<CalendarWorkItemCount[]> {
    return this.http.get<CalendarWorkItemCount[]>(
      AppConfig.settings.backend.url +
        CALENDAR_ITEMS_ENDPOINT +
        '/work' +
        '?idPerson=' +
        idPerson +
        '&date=' +
        date.toDateString()
    );
  }

  public getCalendarItemsPlaner(
    range: DateRange,
    users: AbsencePlanerUserList[]
  ): Observable<CalendarItem[]> {
    return this.http.post<CalendarItem[]>(
      AppConfig.settings.backend.url + CALENDAR_ITEMS_ENDPOINT + '/planer',
      { range, users } as CalendarPlanerParameters
    );
  }

  public getBalanceBookingItems(
    date: string,
    idPerson: number
  ): Observable<CalendarItem[]> {
    return this.http.get<CalendarItem[]>(
      AppConfig.settings.backend.url +
        CALENDAR_ITEMS_ENDPOINT +
        '/balanceBooking' +
        '?PersonID=' +
        idPerson +
        '&StartDate=' +
        date
    );
  }

  public getExpenseItems(
    date: string,
    idPerson: number
  ): Observable<CalendarItem[]> {
    return this.http.get<CalendarItem[]>(
      AppConfig.settings.backend.url +
        CALENDAR_ITEMS_ENDPOINT +
        '/expense' +
        '?PersonID=' +
        idPerson +
        '&StartDate=' +
        date
    );
  }
}
